/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsReplaceAodRulesByIdMutationRequest, AuditReportsReplaceAodRulesByIdMutationResponse, AuditReportsReplaceAodRulesByIdPathParams, AuditReportsReplaceAodRulesById401, AuditReportsReplaceAodRulesById403 } from "../models/AuditReportsReplaceAodRulesById";

export function getAuditReportsReplaceAodRulesByIdUrl(id: AuditReportsReplaceAodRulesByIdPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Replace a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export async function auditReportsReplaceAodRulesById(id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest, config: Partial<RequestConfig<AuditReportsReplaceAodRulesByIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, AuditReportsReplaceAodRulesByIdMutationRequest>({ method : "PUT", url : getAuditReportsReplaceAodRulesByIdUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}